// Grafia corretta degli indirizzi: "VIA DELLA LIBERTÀ 12" -> "Via della Libertà 12".
const PREFIX = /^(via|viale|v\.le|piazza|p\.zza|piazzale|corso|c\.so|largo|vicolo|vico|contrada|c\.da|strada|lungomare|lungotevere|salita|discesa|traversa|località|loc\.|borgo|rione|galleria|passaggio|calle|frazione|fraz\.|circonvallazione|rotonda|piazzetta|via\s+privata|stradone|baglio|cortile)\b/i;
const PARTICLES = new Set(["di", "del", "dello", "della", "dei", "degli", "delle", "d", "da", "dal", "dallo", "dalla", "dai", "dagli", "dalle", "de", "e", "ed", "in", "a", "al", "allo", "alla", "ai", "agli", "alle", "sul", "sullo", "sulla", "sui", "sugli", "sulle", "nel", "nello", "nella", "nei", "negli", "nelle", "per", "con", "tra", "fra", "l", "dell", "all", "nell", "sull", "dall", "coll"]);
const KEEP_UPPER = /^(snc|sn|s\.n\.c\.|bis|ter|[ivxlc]{2,6})$/i;

export function addressCase(val) {
  const s = String(val || "");
  if (!PREFIX.test(s.trim())) return null;
  let first = true;
  return s.replace(/\p{L}+/gu, (w) => {
    const low = w.toLowerCase();
    let out;
    if (!first && PARTICLES.has(low)) out = low;
    else if (!first && KEEP_UPPER.test(w) && /^[ivxlc]+$/i.test(w)) out = w.toUpperCase();
    else if (/^(snc|sn)$/i.test(w)) out = low;
    else out = low.charAt(0).toUpperCase() + low.slice(1);
    first = false;
    return out;
  });
}
